module.exports = __webpack_public_path__ + "static/media/logo_animalcrossing_tw.5c788259.svg";